module.exports = __webpack_public_path__ + "static/media/calendar-icon-gray.f84d2b46.svg";